"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var react_1 = require("react");
var CheckboxIcon_1 = __importDefault(require("../../../Assets/CustomIcons/CheckboxIcon"));
var CardButton_1 = __importDefault(require("../../Atoms/CardButton/CardButton"));
var Text_1 = __importDefault(require("../../Atoms/Text"));
var TextField_1 = __importDefault(require("../TextField/TextField"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var browserAndDeviceDetection_1 = require("../../../Helpers/browserAndDeviceDetection");
var deviceSpecificHandlers_1 = require("../../../Helpers/deviceSpecificHandlers");
var makeIconTileCheckBoxStyling_1 = __importDefault(require("./makeIconTileCheckBoxStyling"));
var material_1 = require("@mui/material");
var IconTileCheckBox = function (_a) {
    var Icon = _a.Icon, id = _a.id, isOtherOption = _a.isOtherOption, onChange = _a.onChange, onClick = _a.onClick, onKeyDown = _a.onKeyDown, otherInputError = _a.otherInputError, otherInputValue = _a.otherInputValue, selected = _a.selected, showText = _a.showText, text = _a.text, subtext = _a.subtext, experimentName = _a.experimentName, hideCheckbox = _a.hideCheckbox, disabled = _a.disabled, minHeight = _a.minHeight;
    var _b = (0, react_1.useState)(selected), isSelected = _b[0], setIsSelected = _b[1];
    var _c = (0, react_1.useState)(false), isFocused = _c[0], setIsFocused = _c[1];
    var _d = (0, react_1.useState)(otherInputValue), otherValue = _d[0], setOtherValue = _d[1];
    var otherInputRef = (0, react_1.useRef)(null);
    var isSubtextPresent = !!subtext;
    var styles = (0, makeIconTileCheckBoxStyling_1.default)({
        showText: showText,
        isSubtextPresent: isSubtextPresent,
        minHeight: minHeight,
    });
    var isTextfield = (isOtherOption && isFocused) || !!otherValue;
    var handleBlur = function (event) {
        if (event) {
            event.stopPropagation();
        }
        if (!isSelected) {
            setIsFocused(false);
            if (!otherValue) {
                setIsSelected(false);
            }
        }
        if (isSelected && isFocused) {
            if (!otherValue) {
                setTimeout(function () {
                    setIsSelected(false);
                    setIsFocused(false);
                }, 100);
            }
        }
    };
    var handleClick = function () {
        onClick({ id: id, selected: !selected });
        if (!isSelected && (0, browserAndDeviceDetection_1.isIOS)() && isOtherOption) {
            (0, deviceSpecificHandlers_1.iosFocusHandler)(otherInputRef);
        }
        setIsSelected(!isSelected);
        setIsFocused(true);
    };
    var handleInputClick = function (e) {
        e.stopPropagation();
        if (otherInputRef.current) {
            otherInputRef.current.focus();
        }
        setIsSelected(true);
        onClick({ id: id, selected: true });
    };
    var handleKeyDown = function (event) {
        if (event) {
            onKeyDown(event);
            if (event.key === 'Enter' && otherInputRef.current) {
                if (!otherValue) {
                    setIsSelected(false);
                    setIsFocused(false);
                }
                otherInputRef.current.blur();
            }
        }
    };
    var onOtherTextFieldChange = function (inputChangeEvent) {
        onChange(inputChangeEvent);
        setOtherValue(inputChangeEvent.value);
        if (inputChangeEvent.value) {
            setIsSelected(true);
        }
        else {
            setIsSelected(false);
        }
    };
    var renderTextContent = function () {
        return subtext ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, { variant: "tileItem", experimentName: experimentName, children: text }), (0, jsx_runtime_1.jsx)(Text_1.default, { variant: "tileItemSubtext", experimentName: experimentName, children: subtext })] })) : ((0, jsx_runtime_1.jsx)(Text_1.default, { variant: "tileItem", experimentName: experimentName, children: text }));
    };
    (0, react_1.useEffect)(function () {
        if (isSelected && otherInputRef.current) {
            otherInputRef.current.focus();
        }
    }, [isSelected]);
    (0, react_1.useEffect)(function () {
        setIsSelected(selected);
    }, [selected]);
    return ((0, jsx_runtime_1.jsxs)(CardButton_1.default, { selected: isSelected, "data-selected": isSelected, onClick: handleClick, onKeyDown: handleKeyDown, "data-testid": "checkboxCardButton", outlined: isSelected, onBlur: handleBlur, experimentName: experimentName, disabled: disabled, fitContent: isSubtextPresent, children: [!hideCheckbox && ((0, jsx_runtime_1.jsx)(Checkbox_1.default, { id: "checkbox-".concat(id), css: styles.checkbox, checked: isSelected, icon: (0, jsx_runtime_1.jsx)(CheckboxIcon_1.default, { isChecked: false }), checkedIcon: (0, jsx_runtime_1.jsx)(CheckboxIcon_1.default, { isChecked: true }), disabled: disabled })), (0, jsx_runtime_1.jsxs)(material_1.Box, { css: styles.container, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { css: styles.icon, children: (0, jsx_runtime_1.jsx)(material_1.Box, { css: styles.imgDiv, children: Icon }) }), isTextfield ? ((0, jsx_runtime_1.jsx)(material_1.Box, { css: styles.otherInput, children: (0, jsx_runtime_1.jsx)(TextField_1.default, { "data-testid": "otherInputTextfield:".concat(id), id: id, placeholder: text, onClick: handleInputClick, onChange: onOtherTextFieldChange, isOtherOption: true, inputRef: otherInputRef, errorMessage: otherInputError ? '' : undefined, value: otherInputValue, experimentName: experimentName, disabled: hideCheckbox }) })) : (showText && renderTextContent())] })] }));
};
IconTileCheckBox.defaultProps = defaultProps_1.default;
exports.default = IconTileCheckBox;
//# sourceMappingURL=IconTileCheckBox.js.map